
function getModule () {
  return document.querySelector('#media-search-module')
}

if (global.htmx) {
  global.htmx.on('htmx:xhr:loadend', () => {
    getModule().classList.remove('loading')
  })
  global.htmx.on('htmx:xhr:loadstart', () => {
    getModule().scrollIntoView({ behavior: 'smooth' })
    getModule().classList.add('loading')
  })
}
